import React from 'react';

import TypedPlaceholder from '../../../components/TypedPlaceholder';

const OpenChannelCreateStatusLoading = () => {
  return <TypedPlaceholder type={'loading'} />;
};

export default OpenChannelCreateStatusLoading;
